export function InfoBlockIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 6C7.44772 6 7 6.44772 7 7V10C7 10.5523 7.44772 11 8 11H12C12.5523 11 13 10.5523 13 10V7C13 6.44772 12.5523 6 12 6H8ZM8.4 7.4V9.6H11.6V7.4H8.4Z"
        fill="currentColor"
      />
      <path
        d="M7 13.7C7 13.3134 7.3134 13 7.7 13H12.3C12.6866 13 13 13.3134 13 13.7C13 14.0866 12.6866 14.4 12.3 14.4H7.7C7.3134 14.4 7 14.0866 7 13.7Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M2.5 5C2.5 3.61929 3.61929 2.5 5 2.5H15C16.3807 2.5 17.5 3.61929 17.5 5V15C17.5 16.3807 16.3807 17.5 15 17.5H5C3.61929 17.5 2.5 16.3807 2.5 15V5ZM5 4.16667C4.53976 4.16667 4.16667 4.53976 4.16667 5V15C4.16667 15.4602 4.53976 15.8333 5 15.8333H15C15.4602 15.8333 15.8333 15.4602 15.8333 15V5C15.8333 4.53976 15.4602 4.16667 15 4.16667H5Z"
        fill="currentColor"
      />
    </svg>
  );
}
